import React from 'react';
import { Frame, Icon, SageClassnames, SageTokens } from '@kajabi/sage-react';
import PropTypes from 'prop-types';

import { MockItem } from './MockItem';

const PAYMENT_ICONS = [
  'CARD_GENERIC',
  'CARD_APPLE',
  'CARD_GPAY',
  'LOGO_AFTERPAY'
]

export const Checkout = ({ breakpoints, hideOrExpandSection }) => {
  return (
    <Frame gap={Frame.GAPS.NONE}>
      {
        breakpoints.sm && <Frame
          direction={Frame.DIRECTIONS.HORIZONTAL}
          padding={Frame.PADDINGS.SM}
        >
          <Frame align={Frame.ALIGNMENTS.CENTER_LEFT} style={{ height: '100%' }}>
            <MockItem
              color={
                SageTokens.COLOR_PALETTE[breakpoints.sm ? 'PRIMARY_200' : 'WHITE']
              }
              height={12}
              width={87}
            />
          </Frame>
          <Frame
            align={Frame.ALIGNMENTS.CENTER_RIGHT}
            direction={Frame.DIRECTIONS.VERTICAL}
            gap={Frame.GAPS['2XS']}
          >
            {Array(3)
              .fill()
              .map((_, index) => (
                <MockItem
                  color={
                    SageTokens.COLOR_PALETTE.PRIMARY_200
                  }
                  height={8}
                  key={`checkout-page-header-${index}`}
                />
              ))}
          </Frame>
        </Frame>
      }
      <Frame
        align={Frame.ALIGNMENTS.CENTER_CENTER}
        background={SageTokens.COLOR_PALETTE.PRIMARY_100}
        className={hideOrExpandSection(1)}
        padding={Frame.PADDINGS.LG}
        style={{ minHeight: 151 }}
      >
        {
          breakpoints.sm && <>
            <MockItem color="#57B3F4" height={12} width={124} />
            <MockItem color={SageTokens.COLOR_PALETTE.PRIMARY_200} height={12} width="100%" />
            <div
              style={{
                backgroundColor: SageTokens.COLOR_PALETTE.PRIMARY_300,
                borderRadius: 8,
                color: SageTokens.COLOR_PALETTE.WHITE,
                padding: '6px 16px',
                textAlign: 'center',
                width: '100%'
              }}
            >
              Pay now
            </div>
          </>
        }
      </Frame>
      <Frame
        className={hideOrExpandSection(1)}
        direction={Frame.DIRECTIONS.HORIZONTAL}
        padding={Frame.PADDINGS[breakpoints.sm ? 'SM' : '2XL']}
      >
        { breakpoints.sm || <Frame className={hideOrExpandSection(3)} style={{ flex: 2}}>
            <Frame gap={Frame.GAPS.SM}>
              <Frame
                background={SageTokens.COLOR_PALETTE.PRIMARY_100}
                style={{ minHeight: 180 }}
              />
              <MockItem color="#57B3F4" width="40%"/>
            </Frame>
            <Frame gap={Frame.GAPS.SM}>
              <MockItem color={SageTokens.COLOR_PALETTE.PRIMARY_200} width="40%"/>
              <MockItem color={SageTokens.COLOR_PALETTE.PRIMARY_100} width="100%"/>
              <MockItem color={SageTokens.COLOR_PALETTE.PRIMARY_100} width="100%"/>
              <MockItem color={SageTokens.COLOR_PALETTE.PRIMARY_100} width="60%"/>
              <MockItem color={SageTokens.COLOR_PALETTE.PRIMARY_100} width="100%"/>
              <MockItem color={SageTokens.COLOR_PALETTE.PRIMARY_100} width="60%"/>
            </Frame>
          </Frame>
        }
        <Frame
          border={Frame.BORDERS.DEFAULT}
          borderRadius={Frame.BORDER_RADII.MD}
          className={hideOrExpandSection(2)}
          gap={Frame.GAPS[breakpoints.sm ? 'SM' : 'MD']}
          padding={Frame.PADDINGS.MD}
          style={{flex: 1}}
        >
          <MockItem color={SageTokens.COLOR_PALETTE.PRIMARY_100} height={12} width="100%"/>
          {
            PAYMENT_ICONS
              .map((iconName) => (
                <Frame
                  direction={Frame.DIRECTIONS.HORIZONTAL}
                  gap={Frame.GAPS.SM}
                  key={`payment-${iconName}`}
                >
                  <Frame width={Frame.WIDTHS.HUG}>
                    <Icon
                      icon={Icon.ICONS[iconName]}
                    />
                  </Frame>
                  <Frame gap={Frame.GAPS['2XS']}>
                    <MockItem
                      color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                      height={8}
                      width={85}
                    />
                    <MockItem
                      color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                      height={8}
                      width={56}
                    />
                  </Frame>
                </Frame>
              ))
          }
          <MockItem color={SageTokens.COLOR_PALETTE.PRIMARY_100} height={12} width="100%"/>
          {
            breakpoints.sm || <div
              style={{
                backgroundColor: SageTokens.COLOR_PALETTE.PRIMARY_300,
                borderRadius: 8,
                color: SageTokens.COLOR_PALETTE.WHITE,
                padding: '6px 16px',
                textAlign: 'center',
                width: '100%'
              }}
            >
              Pay now
            </div>
          }
        </Frame>
      </Frame>
    </Frame>
  );
};

Checkout.propTypes = {
  breakpoints: PropTypes.shape({}).isRequired,
  hideOrExpandSection: PropTypes.func.isRequired,
};
